module.exports = __webpack_public_path__ + "static/img/04.acebe72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/04.png
// module id = vZ3Z
// module chunks = 2